import styled from '@emotion/styled';
import { forwardRef, LegacyRef, MouseEventHandler } from 'react';

type Props = {
  children: React.ReactNode;
  onClick?: MouseEventHandler;
};

const HorizontalFlex = ({ children, onClick, ...props }: Props, ref: LegacyRef<HTMLDivElement>) => (
  <LayoutRoot onClick={onClick} {...props} ref={ref}>
    {children}
  </LayoutRoot>
);

export default forwardRef(HorizontalFlex);

const LayoutRoot = styled.div`
  display: flex;
  flex-direction: row;
`;
